import { WhatsappLogo, Phone, InstagramLogo } from "@phosphor-icons/react";
import { PHONE_TEL, WHATSAPP_URL, INSTAGRAM_URL } from "@/data/content";
import { useLanguage } from "@/i18n";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="relative bg-charcoal pb-10 pt-16">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" />
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-6 text-center md:px-12">
        <p className="font-serif text-xl uppercase tracking-[0.3em] text-[#FAFAFA]">
          {t.brand.first} <span className="text-gold">{t.brand.last}</span>
        </p>
        <p data-testid="footer-tagline" className="text-xs uppercase tracking-[0.3em] text-[#A3A3A3]">
          {t.footer.tagline}
        </p>
        <div className="flex items-center gap-6 text-gold">
          <a data-testid="footer-whatsapp-link" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="transition-colors duration-300 hover:text-gold-bright">
            <WhatsappLogo size={22} weight="duotone" />
          </a>
          <a data-testid="footer-phone-link" href={PHONE_TEL} aria-label="Call" className="transition-colors duration-300 hover:text-gold-bright">
            <Phone size={22} weight="duotone" />
          </a>
          <a data-testid="footer-instagram-link" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="transition-colors duration-300 hover:text-gold-bright">
            <InstagramLogo size={22} weight="duotone" />
          </a>
        </div>
        <p className="text-[11px] tracking-wider text-[#A3A3A3]/60">
          © {new Date().getFullYear()} Charbel Moubarak. {t.footer.rights}
        </p>
      </div>
    </footer>
  );
}
